export const SET_APP_STATE = "SET_APP_STATE";
export const SET_FINGERPRINT = "SET_FINGERPRINT";
export const SET_IS_MOBILE = "SET_IS_MOBILE";

export interface IAppState {
  loading: boolean;
  title?: string;
  subText?: string;
  fingerprint: string;
  isMobile: boolean;
}

export const setAppLoading = (
  loading: boolean,
  title = "",
  subText = ""
): Record<string, unknown> => ({
  type: SET_APP_STATE,
  payload: {
    loading,
    title: title ?? "",
    subText: subText ?? "",
  },
});

export const setFingerprint = (
  fingerprint: string
): Record<string, unknown> => ({
  type: SET_FINGERPRINT,
  payload: fingerprint,
});

export const setIsMobile = (isMobile: boolean): Record<string, unknown> => ({
  type: SET_IS_MOBILE,
  payload: isMobile,
});
